export const FILE_UPLOAD_LIMIT_NUM = 5 // Megabytes
export const FILE_UPLOAD_LIMIT = FILE_UPLOAD_LIMIT_NUM * 1048576
export const FILE_UPLOAD_MULTIPLE_LIMIT_NUM = 3 // Multiple image upload limit